import { useState, useCallback } from "react";

import SystemsService from "../../services/SystemsService";

export function useSystems() {
    const [catalogSystems, setCatalogSystems] = useState([]); 

    const fetchAllSystems = useCallback(async (useClave = false) => {
        setCatalogSystems([]);
        const response = await SystemsService.getSystems(); 
        if (!response.success) return [];    
        const data = response?.data?.map((item) => ({
             id: useClave ? item.clave_sistema : item.id_sistema,
            data: item.nombre_sistema
        }));
        setCatalogSystems(data);
    }, []);

    const fetchMySystems = useCallback(async (useClave = false) => {
        setCatalogSystems([]);
        const response = await SystemsService.getMySystems();
        if (!response.success) return [];
        const data = response?.data?.map((item) => ({
            id: useClave ? item.clave_sistema : item.id_sistema,
            data: item.nombre_sistema, 
        }));
        setCatalogSystems(data);
    }, []);


    return { catalogSystems, fetchAllSystems, fetchMySystems};
}